import * as React from 'react';
import Svg, { Circle, Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = ({ color, ...props }: SvgProps) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            stroke={color ?? ds.colorValue.icon.primary}
            strokeWidth={1.5}
            d="M12.963 14.798c-1.667 1.666-2.5 2.5-3.536 2.5-1.035 0-1.869-.834-3.535-2.5l-1.44-1.44c-.963-.963-1.445-1.445-1.698-2.057-.254-.613-.254-1.294-.254-2.657V7.5c0-2.357 0-3.536.732-4.268C3.964 2.5 5.143 2.5 7.5 2.5h1.144c1.363 0 2.044 0 2.657.254.612.253 1.094.735 2.058 1.699l1.439 1.439c1.666 1.667 2.5 2.5 2.5 3.535 0 1.036-.834 1.87-2.5 3.536l-1.835 1.835Z"
        />
        <Circle cx={7.231} cy={7.2} r={1.141} fill={color ?? ds.colorValue.icon.primary} />
    </Svg>
);
export { SvgComponent as PromoTagOutlineIcon };
